import { Admin, Resource } from 'react-admin';
import dataProviderWithAuth from '../providers/dataProvider';
import authProvider from '../providers/authProvider';
import { UserList, UserCreate, UserEdit, UserShow } from '../components/users';
import { GroupList, GroupCreate, GroupEdit, GroupShow } from '../components/groups';
import { MachineList, MachineShow } from '../components/machines';
import { PrintingList, PrintingShow } from '../components/printings';
import { EventList, EventShow } from '../components/events';
import { TagList, TagShow } from '../components/tags';
import { SystemShow } from '../components/systems';
import { SystemUserShow } from '../components/systemUsers';
import {
  FailureCauseList,
  FailureCauseShow,
  FailureCauseCreate,
  FailureCauseEdit,
} from '../components/failureCauses';
import { AnalyzePrintings } from '../components/analyzePrintings';
import Dashboard from '../components/Dashboard';
import GroupsIcon from '@mui/icons-material/Groups';
import PeopleIcon from '@mui/icons-material/People';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import PrintIcon from '@mui/icons-material/Print';
import EventIcon from '@mui/icons-material/Event';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

const App = () => {
  return (
    <Admin
      dataProvider={dataProviderWithAuth}
      authProvider={authProvider}
      dashboard={Dashboard}
      title={''}
      requireAuth
    >
      {(permissions) => (
        <>
          {permissions === 'Admin' && (
            <>
              <Resource
                name="groups"
                list={GroupList}
                create={GroupCreate}
                edit={GroupEdit}
                show={GroupShow}
                icon={GroupsIcon}
              />
              <Resource
                name="users"
                list={UserList}
                create={UserCreate}
                edit={UserEdit}
                show={UserShow}
                icon={PeopleIcon}
              />
              <Resource
                name="machines"
                list={MachineList}
                show={MachineShow}
                icon={PrecisionManufacturingIcon}
              />
              <Resource name="printings" list={PrintingList} show={PrintingShow} icon={PrintIcon} />
              <Resource name="events" list={EventList} show={EventShow} icon={EventIcon} />
              <Resource name="tags" list={TagList} show={TagShow} icon={LocalOfferIcon} />
              <Resource
                name="analyzePrintings"
                list={AnalyzePrintings}
                icon={AnalyticsIcon}
                options={{ label: 'Analyze Printings' }}
              />
              <Resource name="systems" show={SystemShow} />
              <Resource name="system-users" show={SystemUserShow} />
              <Resource
                name="failure-causes"
                list={FailureCauseList}
                show={FailureCauseShow}
                create={FailureCauseCreate}
                edit={FailureCauseEdit}
                icon={ReportProblemIcon}
                options={{ label: 'Failure Causes' }}
              />
              <Resource name="boards" />
              <Resource name="event-types" />
            </>
          )}
          {permissions === 'Partner' && (
            <>
              <Resource
                name="machines"
                list={MachineList}
                show={MachineShow}
                icon={PrecisionManufacturingIcon}
              />
              <Resource name="printings" list={PrintingList} show={PrintingShow} icon={PrintIcon} />
              <Resource name="events" list={EventList} show={EventShow} icon={EventIcon} />
              <Resource name="tags" list={TagList} show={TagShow} icon={LocalOfferIcon} />
              <Resource
                name="analyzePrintings"
                list={AnalyzePrintings}
                icon={AnalyticsIcon}
                options={{ label: 'Analyze Printings' }}
              />
              <Resource name="systems" show={SystemShow} />
              <Resource name="system-users" show={SystemUserShow} />
              <Resource name="failure-causes" />
              <Resource name="boards" />
              <Resource name="event-types" />
            </>
          )}
        </>
      )}
    </Admin>
  );
};

export default App;
